const two = (n: number) => String(n).padStart(2, '0');

/** «2026-11-05T09:00:00Z» → «05/11/2026», in the organisation's time zone; a date-only too. */
export { formatDate as formatDay, formatDateTime as formatWhen } from '../format-date';

/** An amount in whole cents from a decimal string («148.40» → 14840), never through a fraction. */
export function toCents(amount: string | undefined): number {
  const match = /^(-?)(\d+)\.(\d{2})$/.exec(amount ?? '');
  if (match === null) return 0;
  const cents = Number(match[2]) * 100 + Number(match[3]);
  return match[1] === '-' ? -cents : cents;
}

/** Whole cents as a decimal string: 14840 → «148.40». */
export function fromCents(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  return `${sign}${Math.floor(abs / 100)}.${two(abs % 100)}`;
}

/** A distance for display, it-IT style: «1684.0» → «1.684», «142.5» → «142,5»; else as it came. */
export function formatKm(km: string | undefined): string {
  const match = /^(\d+)\.(\d)$/.exec(km ?? '');
  if (match === null) return km ?? '0';
  const whole = match[1]!.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return match[2] === '0' ? whole : `${whole},${match[2]}`;
}
